module.exports = __webpack_public_path__ + "static/app/img/banner1.c0a41ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/banner1.jpg
// module id = Asfn
// module chunks = 1